import { GeneralTable } from "@/shared/components/ui";
import { useCheckPermissionsArray, useTableFilter, useTableServerSideFiltering } from "@/shared/hooks";
import { Grid, IconButton, Tooltip } from "@mui/material";
import {
  EstadoProspectoEnum,
  TABLE_CONSTANTS
} from "@/shared";
import { useState } from "react";
import { City, ISolicitudEvento, Province } from "@/shared/interfaces";
import { Visibility } from "@mui/icons-material";
import { useFetchSolicitudEvento } from "@/shared/actions/erp/marketing/solicitudEvento.action";
import { useTableColumnsMarketing } from "@/shared/hooks/useTableColumnsMarketing";
import { PermissionsEnum } from "@/auth/interfaces";
import ModalSolicitudEvento from "./ModalSolicitudesEventoCanje/ModalSolicitudEvento";

interface TableRevisionSolicitudEventoProps {
  showCustomActionBtnSpace?: boolean
  enableEditing?: boolean
  estado_prospecto?: EstadoProspectoEnum
}
type ParamsDataSelected = ISolicitudEvento & {
  provincia_data?: Province
  ciudad_data?: City
}


export default function TableRevisionSolicitudEvento({
  showCustomActionBtnSpace = true,
  enableEditing = true,

}: TableRevisionSolicitudEventoProps) {

  useCheckPermissionsArray([
    PermissionsEnum.api_view_solicitudevento,
    PermissionsEnum.api_change_solicitudevento
  ]);

  ///* use state
  const [modal, setModal] = useState(false);
  const [dataSelected, setDataSelected] = useState<ParamsDataSelected>();

  ///* form
  // const form = useForm<FormEditProspecto>({
  //   resolver: yupResolver(newEditarProspecteoSchema),
  // });

  // const {
  //   reset,
  //   control,
  //   formState: { errors },
  // } = form;


  // const {
  //   reset: resetMotivoRechazar,
  // } = formRechazo;

  ///* Hooks
  const {
    columnsSolicitudEvento
  } = useTableColumnsMarketing();

  const {
    pagination,

    setPagination,
  } = useTableFilter();

  const { pageIndex } = pagination;

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { isLoading, data: SolicitudEventoData, isRefetching } =
    useFetchSolicitudEvento({
      page: pageIndex + 1,
      ...filterObject,
      filterByState: false
    });





  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>

        </Grid>

        <Grid item xs={12}>
          <GeneralTable<ISolicitudEvento>
            columns={columnsSolicitudEvento}
            data={SolicitudEventoData?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            ///* search
            enableGlobalFilter={false}
            enableSorting={false}
            // onGlobalFilterChange={setGlobalFilter}
            ///* pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={SolicitudEventoData?.data?.count}
            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}

            // crud
            canEdit={false}
            enableEditing={enableEditing}
            showCustomActionBtnSpace={showCustomActionBtnSpace}
            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_MEDIUM}

            customActionBtnSpace={(value) => {
              return (
                <Grid container>
                  <Grid item >
                    <Tooltip title={'Ver Registro'} placement="top">
                      <IconButton
                        onClick={() => {
                          setModal(true)
                          setDataSelected(value!)
                        }
                        }
                      >
                        <Visibility />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
              )
            }
            }
          />
        </Grid>
      </Grid>


      <ModalSolicitudEvento
      showModal={modal}
      setShowModal={setModal}
      dataSelected={dataSelected!}
      />


    </>

  );



}